import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import TextArea from '../../../common/components/TextArea.js'
import Select from '../../../common/components/Select.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../common/components/Button/ButtonSecondary.js'
import {onlyIfForm, useSelector} from '../../../store.js'

import AddressForm from './AddressForm.js'
import ValidationPanel from './ValidationPanel.js'
import {
  saveAddress,
  removeModalForm,
  modalFormSelector,
  errorsSelector,
  addressCopyOptionsSelector,
  updateAddressFromID,
  updateModalForm,
  setAddressFromParse,
  resetAddress,
} from './editAddressFunctions.js'
import {PRIVACY_MASK} from '../../../common/analytics/index.js'
import Icon from '../../../common/icons/Icon.js'

function EditAddressModal({form}) {
  const errors = useSelector(errorsSelector)
  const addressCopyOptions = useSelector(addressCopyOptionsSelector)

  return (
    <ConfirmModal
      title={form.modalTitle}
      modalSize="lg"
      isSaving={form.isSaving}
      confirmText={form.confirmText}
      cancelText="Cancel"
      onConfirm={() => saveAddress()}
      onCancel={() => removeModalForm()}
      error={form.serverError}
      isDisabled={errors.preventSave}
    >
      <div className="row">
        <div className="columns medium-8">
          <AddressForm form={form} errors={errors} />
        </div>
        <div className="medium-4 columns">
          <div className="divider--left lg">
            {form.willValidate && <ValidationPanel />}
            {form.hasAddressShortcuts && (
              <dl
                className={`list ${
                  form.willValidate ? 'divider--top margin-top-25' : ''
                }`}
              >
                <dt className="list__title fs-00">
                  <span className="margin-right-3">Address Shortcuts</span>
                </dt>
                <dd className="list__item">
                  <Select
                    value=""
                    className="w-100 border-box"
                    onChange={(value) => {
                      const [, type, id] =
                        value.match(/^(supplier_id|warehouse_id)__(\d+)$/) || []

                      if (type && id) {
                        updateAddressFromID(type, Number(id))
                      }
                    }}
                  >
                    {addressCopyOptions.map(
                      ({value, display, disabled}, index) => (
                        <option
                          key={disabled ? `disabled_${index}` : value}
                          value={value}
                          disabled={disabled}
                        >
                          {display}
                        </option>
                      ),
                    )}
                  </Select>
                </dd>
              </dl>
            )}
            <dl
              className={`list ${
                form.willValidate || form.hasAddressShortcuts
                  ? 'divider--top margin-top-25'
                  : ''
              }`}
            >
              <dt className="list__title fs-00">
                <span className="margin-right-3">Paste Address</span>
                <a
                  className="inline-text-button no-underline v-align-middle"
                  href="https://support.ordoro.com/pasted-address-lines/"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon name="sym-support" className="fs-n0" />
                </a>
              </dt>
              <dd className="list__item">
                <TextArea
                  className={`textarea textarea--mh-auto ${PRIVACY_MASK}`}
                  rows="7"
                  value={form.addressFreeText}
                  onChange={(value) =>
                    updateModalForm({
                      addressFreeText: value,
                    })
                  }
                />
              </dd>
              <dd className="list__item">
                <ButtonPrimary
                  className="margin-right-5"
                  size="x-sm"
                  alt
                  onClick={() => setAddressFromParse()}
                  isDisabled={!form.addressFreeText}
                >
                  Update Form
                </ButtonPrimary>
                <ButtonSecondary size="x-sm" onClick={() => resetAddress()}>
                  Reset
                </ButtonSecondary>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </ConfirmModal>
  )
}

export default onlyIfForm(EditAddressModal, modalFormSelector)
